export const servicesData = [
  {
    id: 'safe-space',
    title: 'Safe Space',
    subtitle: 'A nonjudgmental, inclusive environment for sharing and healing.',
    heroImage: '/images/(6).jpeg',
    duration: 'Ongoing',
    format: 'Group sessions & Individual support',
    availability: 'Weekly sessions available',
    overview: [
      'Safe Space provides a welcoming, confidential environment where individuals can share their experiences without fear of judgment or stigma. This foundational service creates the trust and safety necessary for meaningful healing and growth.',
      'Our approach emphasizes peer support, active listening, and mutual respect. Whether you\'re navigating mental health challenges, processing trauma, or seeking connection, Safe Space offers a community where your voice matters.'
    ],
    features: [
      'Confidential group sessions',
      'Peer-led support circles',
      'Individual check-ins available',
      'Trauma-informed approach',
      'Culturally sensitive environment',
      'Flexible scheduling options'
    ],
    expectations: [
      'You\'ll join a small group of individuals who understand your journey. Sessions are facilitated by trained peer supporters who have lived experience with mental health challenges.',
      'The space is yours to share as much or as little as you feel comfortable. There\'s no pressure to participate in any specific way—your presence and comfort are the priority.'
    ],
    gallery: [
      '/images/(14).jpeg',
      '/images/(19).jpeg'
    ],
    related: [
      { id: 'peer-support', title: 'Peer Support', description: 'Structured peer-led mentorship programs' },
      { id: 'professional-assistance', title: 'Professional Assistance', description: 'Clinical support and counseling' }
    ]
  },
  {
    id: 'professional-assistance',
    title: 'Professional Assistance',
    subtitle: 'Life coaching, counseling psychology, and trauma-informed care.',
    heroImage: '/images/(14).jpeg',
    duration: '6-12 weeks typical',
    format: 'One-on-one & Group sessions',
    availability: 'By appointment',
    overview: [
      'Professional Assistance combines evidence-based therapeutic approaches with lived experience insights. Our licensed professionals work alongside peer supporters to provide comprehensive mental health support.',
      'This service bridges clinical excellence with the authentic understanding that comes from shared experience, ensuring you receive both professional expertise and genuine empathy.'
    ],
    features: [
      'Licensed counselors and therapists',
      'Life coaching services',
      'Trauma-informed therapy',
      'Cognitive behavioral approaches',
      'Crisis intervention support',
      'Personalized treatment plans'
    ],
    expectations: [
      'Your journey begins with an initial assessment to understand your unique needs and goals. From there, we\'ll work together to create a personalized support plan.',
      'Sessions may include individual therapy, group counseling, or a combination of both, depending on what serves you best.'
    ],
    gallery: [
      '/images/(111).jpeg',
      '/images/(110).jpeg'
    ],
    related: [
      { id: 'safe-space', title: 'Safe Space', description: 'Supportive group environments' },
      { id: 'personalized-wellness', title: 'Personalized Wellness', description: 'Tailored wellness programs' }
    ]
  },
  {
    id: 'peer-support',
    title: 'Peer Support',
    subtitle: 'Peer-led group sessions and mentorship models for healing and empowerment.',
    heroImage: '/images/(2).jpeg',
    duration: 'Ongoing',
    format: 'Group sessions & Mentorship',
    availability: 'Weekly & Monthly options',
    overview: [
      'Peer Support leverages the power of shared experience to create meaningful connections and sustainable healing. Our peer supporters are trained individuals who have navigated their own mental health journeys.',
      'This service recognizes that sometimes the most powerful support comes from someone who truly understands—not just professionally, but personally.'
    ],
    features: [
      'Trained peer supporters',
      'Mentorship programs',
      'Peer-led group sessions',
      'Recovery-focused approach',
      'Skill-building workshops',
      'Community connection'
    ],
    expectations: [
      'You\'ll be matched with peer supporters who share similar experiences or goals. These relationships provide ongoing support, accountability, and genuine understanding.',
      'Group sessions create opportunities to learn from others, share strategies, and build a network of support that extends beyond formal sessions.'
    ],
    gallery: [
      '/images/(20).jpeg',
      '/images/(113).jpeg'
    ],
    related: [
      { id: 'safe-space', title: 'Safe Space', description: 'Nonjudgmental group environments' },
      { id: 'raising-awareness', title: 'Raising Awareness', description: 'Community education programs' }
    ]
  },
  {
    id: 'personalized-wellness',
    title: 'Personalized Wellness',
    subtitle: 'Tailored support plans using culturally relevant tools and approaches.',
    heroImage: '/images/(19).jpeg',
    duration: '3-6 months',
    format: 'Individual & Group',
    availability: 'Flexible scheduling',
    overview: [
      'Personalized Wellness recognizes that healing is not one-size-fits-all. We work with you to create a customized wellness plan that honors your cultural background, personal values, and unique circumstances.',
      'This service integrates traditional and modern approaches, ensuring that your wellness journey feels authentic and sustainable for your life.'
    ],
    features: [
      'Customized wellness plans',
      'Cultural competency',
      'Holistic approaches',
      'Goal-setting support',
      'Progress tracking',
      'Flexible program structure'
    ],
    expectations: [
      'We\'ll start by understanding your background, values, and goals. Together, we\'ll design a wellness plan that incorporates approaches and tools that resonate with you.',
      'Regular check-ins ensure your plan evolves with your needs, and you\'ll have access to various resources and support modalities.'
    ],
    gallery: [
      '/images/(13).jpeg',
      '/images/(106).jpeg'
    ],
    related: [
      { id: 'professional-assistance', title: 'Professional Assistance', description: 'Clinical support services' },
      { id: 'lmhe-engagement', title: 'LMHE Engagement', description: 'Lived experience programs' }
    ]
  },
  {
    id: 'raising-awareness',
    title: 'Raising Awareness',
    subtitle: 'Community education, storytelling, and advocacy for reducing mental health stigma.',
    heroImage: '/images/(20).jpeg',
    duration: 'Ongoing programs',
    format: 'Workshops & Events',
    availability: 'Monthly events',
    overview: [
      'Raising Awareness works to break down the barriers of stigma through education, storytelling, and community engagement. We believe that understanding and empathy are powerful tools for change.',
      'This service includes workshops, community events, and advocacy initiatives that empower individuals and communities to have open, honest conversations about mental health.'
    ],
    features: [
      'Community workshops',
      'Storytelling events',
      'Stigma reduction programs',
      'Educational resources',
      'Advocacy training',
      'Public speaking opportunities'
    ],
    expectations: [
      'Join workshops and events designed to educate and inspire. Share your story if you choose, or simply listen and learn from others.',
      'You\'ll gain tools and knowledge to advocate for mental health awareness in your own community, whether that\'s through conversations, events, or organized initiatives.'
    ],
    gallery: [
      '/images/(101).jpeg',
      '/images/(19).jpeg'
    ],
    related: [
      { id: 'peer-support', title: 'Peer Support', description: 'Peer-led programs' },
      { id: 'lmhe-engagement', title: 'LMHE Engagement', description: 'Lived experience advocacy' }
    ]
  },
  {
    id: 'lmhe-engagement',
    title: 'LMHE Engagement',
    subtitle: 'Tools and training for individuals, researchers, and organizations looking to partner ethically with people with lived mental health experience.',
    heroImage: '/images/(13).jpeg',
    duration: 'Training: 2-4 weeks',
    format: 'Workshops & Consultations',
    availability: 'Scheduled sessions',
    overview: [
      'LMHE Engagement provides essential training and guidance for anyone seeking to work ethically and effectively with people who have lived mental health experience.',
      'This service ensures that partnerships, research, and interventions are designed with respect, dignity, and genuine collaboration at their core.'
    ],
    features: [
      'Ethical engagement training',
      'Research collaboration support',
      'Organizational consulting',
      'Partnership development',
      'Best practices guidance',
      'Ongoing support and resources'
    ],
    expectations: [
      'Whether you\'re a researcher, organization, or individual seeking to engage with LMHE communities, we\'ll provide training and guidance on ethical, respectful approaches.',
      'You\'ll learn how to create partnerships that honor lived experience, ensure fair compensation, and prioritize the well-being of all participants.'
    ],
    gallery: [
      '/images/(107).jpeg',
      '/images/(20).jpeg'
    ],
    related: [
      { id: 'personalized-wellness', title: 'Personalized Wellness', description: 'Individual support programs' },
      { id: 'raising-awareness', title: 'Raising Awareness', description: 'Community education' }
    ]
  }
]
